import { render } from "./PrimaryNavigation.vue.js?vue&type=template&id=fbf51c8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=template&id=fbf51c8c"
import script from "./PrimaryNavigation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/dynamic-components/shared-elements/navigation/PrimaryNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbf51c8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbf51c8c', __exports__)) {
    api.reload('fbf51c8c', __exports__)
  }
  
  module.hot.accept("./PrimaryNavigation.vue.js?vue&type=template&id=fbf51c8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=template&id=fbf51c8c", () => {
    api.rerender('fbf51c8c', render)
  })

}


export default __exports__